import { Helmet } from 'react-helmet';
import { useEffect, useState } from 'react';

// ✅ Import from src/assets so Vite processes & hashes them
import lightFavicon from 'assets/favicon.ico';
import darkFavicon from 'assets/favicon-white.ico';

export function FaviconManager() {
  const [isDark, setIsDark] = useState(window.matchMedia('(prefers-color-scheme: dark)').matches);

  useEffect(() => {
    const media = window.matchMedia('(prefers-color-scheme: dark)');
    const listener = (e: MediaQueryListEvent) => setIsDark(e.matches);
    media.addEventListener('change', listener);
    return () => media.removeEventListener('change', listener);
  }, []);

  return (
    <Helmet>
      <link rel="icon" href={isDark ? darkFavicon : lightFavicon} />
    </Helmet>
  );
}
